import { UI } from '../nextpage';

export class Drawers {
    constructor(private NP: UI) {
        // Drawers component

        // Register the default click event for drawers panel headings.
        this.NP.registerEvent("drawersHeadingClick", (e: Event) => {
            const thisHeading = e.target as HTMLDivElement;
            // Determine whether this panel-heading is currently selected.
            const toggleSelected = thisHeading.getAttribute('aria-selected') === "false";
            /*
                Toggle the aria-selected and aria-expanded attributes of the panel-heading and panel-content based
                on the toggleSelected flag. Then set the aria-selected and aria-expanded attributes of all sibling
                panel-heading and panel-content elements to false (only one drawer is visible at a time).
            */
            const allHeadings: NodeListOf<HTMLDivElement> = thisHeading.parentElement.querySelectorAll(".panel-heading");
            const allContent: NodeListOf<HTMLDivElement> = thisHeading.parentElement.querySelectorAll(".panel-content");
            const headingIndex = Array.prototype.indexOf.call(allHeadings, thisHeading);

            allHeadings.forEach((heading: HTMLDivElement, i) => {
                const toggleState = i === headingIndex ? toggleSelected : false;
                this.NP.toggleAriaState(heading, "selected", toggleState);
            });
            allContent.forEach((content: HTMLDivElement, i) => {
                const toggleState = i === headingIndex ? toggleSelected : false;
                this.NP.toggleAriaState(content, "expanded", toggleState);
            });
        });

        // Define the component function to enable drawers on the provided selector
        this.NP.components.drawers = (selector: string | Element | NodeListOf<Element> | Array<Element>): void => {
            this.NP.getComponentSelector(selector).forEach((drawer: HTMLDivElement) => {
                drawer.querySelectorAll(".panel-heading").forEach((heading) => {
                    this.NP.mapAriaState(heading, "selected");
                    heading.addEventListener("click", (ev: Event) => { this.NP.events.drawersHeadingClick(ev); });
                });
                drawer.querySelectorAll(".panel-content").forEach((content) => {
                    this.NP.mapAriaState(content, "expanded");
                });
            });
        }
    }
}